export const getAdminLandingPath = (profile, assignModule) => {
  if (!profile) return "/";
  const isSuperAdmin =
    profile?.role?.slug === "superadmin" ||
    profile?.role?.name === "SuperAdmin" ||
    profile?.email === "superadmin@udrivo.in";
  if (isSuperAdmin) return "/dashboard";

  const isNewType = profile?.employeeType === "new";
  if (isNewType) {
    if (assignModule?.driver?.enabled) return "/drivers";
    if (assignModule?.rides?.enabled) return "/rides";
    if (assignModule?.taxesCommission?.enabled) return "/tax-commission";
    return "/profile";
  }

  return "/drivers";
};
